import React, { useState, useEffect } from 'react'
import { unstable_batchedUpdates } from 'react-dom'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

//Services
import { getBusinessTerms, createTerm, updateTerm, deleteTerm } from '../../../_services/lender.service'
import { businessService } from '../../../_services/business.service'

//Actions
import { modalActions } from '../../../_actions'

//Components
import { S_EditableTable } from '../../../_components/EditableTable'
import { FormField } from '../../../_components/Forms/FormField'
import { S_ControlsButton } from '../../../_components/ControlsButton'
import { FaPlus } from 'react-icons/fa'
import { IconContext } from 'react-icons'
import { Button } from '../../../_components/Button'
import { S_FormInput, S_FormSelect } from '../../../_components/Forms/FormInput/FormInput.styles'
import { FeeSummary } from '../../../_components/Fees/FeeSummary/FeeSummary'
import { FeeEditor } from './FeeEditor/FeeEditor'
import { generateFactoringFeeSummary } from './factoringFeesHelper'
import { S_FeeSummaryContainer } from '../../../_components/Fees/FeeSummary/FeeSummaryContainer'
import { currencyToNum, showNotification } from 'legacy/_helpers'

export const S_BusinessFactoringFees = styled.div`
  .field-container {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
  }
  .value-fields {
    display: flex;
    flex-grow: 1;
    flex-basis: 0;
    justify-content: space-between;
  }
  .field-label {
    flex-grow: 2;
    flex-basis: 0;
  }
  .field-input {
    width: 100%;
  }
  .right-space {
    margin-right: 1px;
  }
  .add-icon {
    margin-right: 4px;
  }
  .table-controls-btn {
    float: right;
    margin-left: auto;
  }
  .table-controls-btn:last-child {
    margin-right: 0;
  }
  .table-field {
    padding-left: 5px;
  }
  ${S_ControlsButton} {
    margin-top: 0;
  }
  ${S_EditableTable} {
    margin-top: 32px;
    ${S_FormInput}:disabled {
      cursor: not-allowed;
    }
    ${S_FormSelect} {
      width: 100%;
      border: none;
      outline: none;
    }
  }
  h4 {
    margin-top: 32px;
    margin-bottom: 16px;
  }
`

const S_DeleteModal = styled.div`
  h3 {
    margin-bottom: 16px;
  }
  .body {
    margin-bottom: 16px;
  }
  .destroy {
    margin-left: 16px;
  }
`

let synchronousTerms = []
export const BusinessFactoringFees = ({ businessId, isModal = false }) => {
  const [terms, setTerms] = useState(null)
  const [advanceRateTerm, setadvanceRateTerm] = useState(null)
  const [advanceRate, setAdvanceRate] = useState(0)
  const [creatingAdvanceRate, setCreatingAdvanceRate] = useState(false)
  const [loading, setLoading] = useState(false)
  const [readyForRender, setReadyForRender] = useState(false) //Using this to keep default value useable and fields uncontrolled
  const [business, setBusiness] = useState(null)

  const dispatch = useDispatch()
  const openModal = (content, props) => {
    dispatch(modalActions.openModal(content, props))
  }
  const closeModal = () => {
    dispatch(modalActions.closeModal())
  }

  const columns = [
    {
      id: 'type',
      label: 'Fee Type',
      type: 'select',
      className: 'table-field',
      options: [
        {
          value: 'FeeOneTime',
          display: 'One Time',
        },
        {
          value: 'FeeTiered',
          display: 'Tiered',
        },
        {
          value: 'FeeRecurring',
          display: 'Recurring',
        },
      ],
      validate: (value) => {
        return null
      },
    },
    {
      id: 'range_begin',
      label: 'Starting Day',
      type: 'number',
      className: 'table-field',
      validate: (value) => {
        return null
      },
    },
    {
      id: 'value',
      label: 'Charge X%',
      type: 'percent',
      className: 'table-field',
      validate: (value) => {
        return null
      },
    },
    {
      id: 'range_increment',
      label: 'Every X Days',
      type: 'number',
      className: 'table-field',
      validate: (value) => {
        return null
      },
    },
    {
      id: 'range_end',
      label: 'Until X Days',
      type: 'number',
      className: 'table-field',
      validate: (value) => {
        return null
      },
    },
    {
      id: 'calculated_fee_rate',
      label: 'Fee Rate',
      type: 'percent',
      className: 'table-field',
      validate: (value) => {
        return null
      },
      disabled: true,
    },
  ]

  const loadFees = async () => {
    await getBusinessTerms(businessId).then((terms) => {
      synchronousTerms = terms.filter((t) => t.type !== 'AdvanceRate')
      unstable_batchedUpdates(() => {
        setadvanceRateTerm(terms.find((t) => t.type == 'AdvanceRate'))
        setAdvanceRate(
          terms.find((t) => t.type == 'AdvanceRate') ? Number(terms.find((t) => t.type == 'AdvanceRate').value) : 0
        )
        setTerms(
          terms
            .filter((t) => t.type !== 'AdvanceRate')
            .map((term) => {
              if (term.range_begin) {
                term.range_begin = Math.floor(Number(term.range_begin))
              }
              if (term.range_end) {
                term.range_end = Math.floor(Number(term.range_end))
              }
              if (term.range_end === 999) {
                term.range_end = null
              }
              if (term.range_increment) {
                term.range_increment = Math.floor(Number(term.range_increment))
              }
              //Correct type for UI Display
              if (term.ui_type && term.ui_type.includes('DailyRate')) {
                term.type = 'FeeRecurring'
              } else if (term.ui_type && term.ui_type.includes('EveryXDays')) {
                term.type = 'FeeTiered'
              }
              return term
            })
        )
      })
    })
  }
  useEffect(() => {
    if (!loading && !terms) {
      setLoading(true)
      loadFees().then(() => {
        setLoading(false)
        setReadyForRender(true)
      })
    }
  })

  useEffect(() => {
    businessService.getBusiness(businessId).then(setBusiness)
  }, [])

  const addTerm = async () => {
    openModal(FeeEditor, {
      businessId,
      onSave: () => {
        loadFees()
        closeModal()
      },
    })
  }

  const handleChangeMinimumFactoringFee = async ({ target }) => {
    try {
      const minimumFactoringFee = currencyToNum(target.value)
      await businessService.updateBusiness('minimum_factoring_fee', minimumFactoringFee, businessId)
      showNotification('Minimum Factoring Fee updated successfully', 'success')
    } catch (e) {
      showNotification('Failed to update Minimum Factoring Fee', 'error')
      console.error('Failed to update Minimum Factoring Fee', e)
    }
  }

  return readyForRender ? (
    <S_BusinessFactoringFees>
      <h3>{`${business ? `${business.business_name} ` : ''}Factoring Terms`}</h3>
      {/* TODO: implement correct frontend for the Factoring Terms */}
      <div className="field-container">
        <div className={`field-label`}>Advance Rate</div>
        <div className="value-fields">
          <FormField
            className={`field-input`}
            defaultValue={advanceRate}
            onBlur={() => {
              if (advanceRateTerm) {
                setadvanceRateTerm({ ...advanceRateTerm, value: advanceRate })
                updateTerm(advanceRateTerm.id, { value: advanceRate })
              } else if (!creatingAdvanceRate) {
                setCreatingAdvanceRate(true)
                createTerm({ type: 'AdvanceRate', value: advanceRate }, businessId).then((term) => {
                  setadvanceRateTerm(term)
                  setCreatingAdvanceRate(false)
                })
              }
            }}
            onChange={(val) => {
              setAdvanceRate(val)
            }}
            type="percent"
          />
        </div>
      </div>
      <div className="field-container">
        <div className={`field-label`}>Reserve Rate</div>
        <div className="value-fields">
          <FormField className={`field-input`} disabled={true} type="percent" value={1 - advanceRate} />
        </div>
      </div>
      <div className="field-container">
        <div className={`field-label`}>Escrow Reserves?</div>
        <div className="value-fields">
          <FormField checked={true} className={`field-input`} disabled={true} type="checkbox" />
        </div>
      </div>
      <div className="field-container">
        <div className={`field-label`}>Minimum Factoring Fee</div>
        <div className="value-fields">
          <FormField
            className={`field-input`}
            disabled={false}
            onBlur={handleChangeMinimumFactoringFee}
            type="currency"
            value={business?.minimum_factoring_fee || 0.0}
          />
        </div>
      </div>
      <div className="field-container">
        <div className={`field-label`}>Current Rates</div>
        <div className="value-fields">
          <Button className={`table-controls-btn`} icon="add" isLoading={false} onClick={addTerm}>
            <IconContext.Provider value={{ size: '16px', className: 'add-icon' }}>
              {
                <>
                  <FaPlus />
                  {`New Term`}
                </>
              }
            </IconContext.Provider>
          </Button>
        </div>
      </div>
      <S_FeeSummaryContainer>
        {terms.map((t) => {
          const feeToEdit = { ...t }

          if (t.type === 'FeeRecurring') {
            feeToEdit.value *= feeToEdit.days_in_year || 365
          }

          return (
            <FeeSummary
              fee={t}
              key={t.id}
              onDeleteClick={(fee) => {
                openModal(() => {
                  return (
                    <S_DeleteModal>
                      <h3>Confirm</h3>
                      <div className={'body'}>Are you sure you want to delete this fee?</div>
                      <div className={'controls'}>
                        <Button onClick={closeModal}>Cancel</Button>
                        <Button
                          className={'destroy'}
                          onClick={() => {
                            deleteTerm(fee.id).then(() => {
                              loadFees()
                              closeModal()
                            })
                          }}
                        >
                          Delete
                        </Button>
                      </div>
                    </S_DeleteModal>
                  )
                })
              }}
              onEditClick={(fee) => {
                openModal(FeeEditor, {
                  businessId,
                  onSave: () => {
                    loadFees()
                    closeModal()
                  },
                  feeToEdit: {
                    ...feeToEdit,
                    has_range_end: fee.range_end ? 'true' : 'false',
                  },
                })
              }}
              summary={generateFactoringFeeSummary(t)}
            />
          )
        })}
      </S_FeeSummaryContainer>
    </S_BusinessFactoringFees>
  ) : null
}
